import styled, { css } from 'styled-components';
import { device, size } from '../../styles/devices';
import { SIZING, COLORS } from '../../styles/variables';

export const Container = styled.div`
  background-color: transparent;
  font-family: 'Audi Type';
  @media ${device.tablet} {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  @media ${device.laptop} {
    padding: 4px 90px 0px;
  }
  @media ${device.laptopL} {
    padding: 4px 189px 0px;
  }
`;

export const InnerContainer = styled.div`
  .ReactCollapse--collapse {
    transition: height 300ms;
  }
  margin: 0 auto 36px;
  @media ${device.tablet} {
    margin-bottom: 0;
    padding-left: 24px;
    padding-right: 24px;
    margin: unset;
  }
  @media ${device.laptop} {
    width: 870px;
    align-self: center;
  }
`;

export const PriceRow = styled.div<{
  alignItems?: string;
  hasIndent?: boolean;
  noBottomBorder?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  @media ${device.tablet} {
    align-items: ${(props) => (props?.alignItems ? props.alignItems : 'flex-start')};
    gap: 96px;
    flex-direction: row;
  }
  justify-content: space-between;
  align-self: stretch;
  margin-left: ${({ hasIndent }) => (hasIndent ? '32px' : '')};
  margin-right: ${({ hasIndent }) => (hasIndent ? '64px' : '')};
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: ${({ noBottomBorder }) => noBottomBorder && 'unset'};
  ${({ noBottomBorder }) => {
    if (noBottomBorder)
      return css`
        border-bottom: unset;
        padding-bottom: unset;
      `;
    return css`
      border-bottom: 1px solid ${COLORS.grey15};
    `;
  }}
`;

export const PriceInfo = styled.div``;

export const Label = styled.div<{ color?: string; isBold?: boolean }>`
  color: ${(props) => (props.color ? props.color : COLORS.grey80)};
  font-family: 'Audi Type';
  font-size: 16px;
  font-style: normal;
  font-weight: ${({ isBold }) => (isBold ? '700' : '400')};
  line-height: 24px;
  letter-spacing: 0.003px;
  @media ${device.tablet} {
    max-width: 415px;
  }
`;

export const MainPrice = styled.div<{ color?: string }>`
  color: ${(props) => (props.color ? props.color : COLORS.grey80)};
  font-family: 'Audi Type';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.002px;
  @media ${device.laptop} {
    font-size: 24px;
    line-height: 36px;
  }
`;

export const AmountWrapper = styled.div`
  position: relative;
`;

export const InfoIconContainer = styled.button`
  position: absolute;
  right: -44px;
  top: -13px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
  margin: 0;
  padding: 0;
  border: none;
`;

export const Legal = styled.div`
  padding: 0 16px 16px;

  @media ${device.tablet} {
    padding: 0 48px 48px;
  }
  @media ${device.tablet} {
    padding: 0 60px 60px;
  }
`;

export const DisclaimerTitleWrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
`;

export const TextContainer = styled.div`
  font-family: 'Audi Type';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
`;

export const HeadlineOrder3 = styled.h3<{ isbold?: boolean }>`
  font-family: 'Audi Type';
  letter-spacing: 0.002px;
  font-size: 20px;
  line-height: 32px;
  font-weight: ${({ isbold }) => (isbold ? '700' : '400')};
  letter-spacing: 0.003px;
  color: ${COLORS.black};
`;

export const HeadlineOrder4 = styled.h3<{ isbold?: boolean }>`
  font-family: 'Audi Type';
  letter-spacing: 0.002px;
  font-size: 16px;
  line-height: 24px;
  font-weight: ${({ isbold }) => (isbold ? '700' : '400')};
  letter-spacing: 0.003px;
  color: ${COLORS.black};
`;
